import React from "react";

import SyDialog from "../../../components/SyDialog";
import { REVIEWS_COPY } from "../reviewsCopy";

import "../styles.css";

const DeleteReviewDialog = ({ busy = false, onConfirm, onCancel }) => (
  <SyDialog
    open
    size="sm"
    className="rv-dialog rv-confirm-dialog"
    title={REVIEWS_COPY.deleteConfirm.title}
    onClose={onCancel}
    footer={
      <div className="rv-form-actions">
        <button type="button" className="rv-btn rv-btn-outline" onClick={onCancel}>
          Cancel
        </button>

        <button
          type="button"
          className="rv-btn rv-btn-danger"
          disabled={busy}
          onClick={onConfirm}
        >
          {busy ? "Deleting…" : "Delete"}
        </button>
      </div>
    }
  >
    <span className="rv-confirm-mark" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M12 3.4 21 19.6H3L12 3.4Z" />
        <path d="M12 9.4v4.3" />
        <circle cx="12" cy="16.5" r="0.9" />
      </svg>
    </span>

    <p className="rv-confirm-text">{REVIEWS_COPY.deleteConfirm.message}</p>
  </SyDialog>
);

export default DeleteReviewDialog;
